import { Prisma } from "@prisma/client";
import { BuyableItemHandler, BuyableItemOrganiser } from "../buyable-item.types";

type PartialExhibitorProfilesPack2CreditsBuyableItem = {
  exhibitorProfilesPack2CreditsOrganiser?: { id: string } | null;
};

type ExhibitorProfilesPack2CreditsBuyableItem = {
  exhibitorProfilesPack2CreditsOrganiser: { id: string };
};

type ExhibitorProfilesPack2CreditsWithOrganiser = {
  exhibitorProfilesPack2CreditsOrganiser: BuyableItemOrganiser;
};

const GROUP_KEY_PREFIX = "exhibitorProfilesPack2Credits";

export const ExhibitorProfilesPack2CreditsBuyableItemHandler = {
  displayName: "Profils exposants pack 2",
  isCumulative: true,
  accounting: {
    generalAccountCode: "706505",
    invoiceLabel: "Profils exposants pack 2",
  },

  getOrganiser(item: ExhibitorProfilesPack2CreditsWithOrganiser): BuyableItemOrganiser {
    return item.exhibitorProfilesPack2CreditsOrganiser;
  },

  isValid(item: PartialExhibitorProfilesPack2CreditsBuyableItem): boolean {
    return !!item.exhibitorProfilesPack2CreditsOrganiser?.id;
  },

  findEquivalent(
    item: PartialExhibitorProfilesPack2CreditsBuyableItem,
  ): Prisma.BuyableItemWhereInput {
    return {
      exhibitorProfilesPack2CreditsOrganiser: {
        id: item.exhibitorProfilesPack2CreditsOrganiser?.id,
      },
    };
  },

  create({
    exhibitorProfilesPack2CreditsOrganiser,
  }: ExhibitorProfilesPack2CreditsBuyableItem): Omit<Prisma.BuyableItemCreateInput, "buyableType"> {
    return {
      exhibitorProfilesPack2CreditsOrganiser: {
        connect: {
          id: exhibitorProfilesPack2CreditsOrganiser.id,
        },
      },
    };
  },

  parseGroupKeyAsWhere(groupKey: string): Prisma.BuyableItemWhereInput {
    if (!ExhibitorProfilesPack2CreditsBuyableItemHandler.isGroupKey(groupKey)) {
      throw new Error(`Invalid group key for exhibitor profiles pack 2 credits: ${groupKey}`);
    }

    const [, organiserId] = groupKey.split("|");
    return {
      exhibitorProfilesPack2CreditsOrganiser: {
        id: organiserId,
      },
    };
  },

  isGroupKey(groupKey: string): boolean {
    return groupKey.startsWith(`${GROUP_KEY_PREFIX}|`);
  },

  getGroupKey(item: PartialExhibitorProfilesPack2CreditsBuyableItem): string {
    const organiserId = item.exhibitorProfilesPack2CreditsOrganiser?.id;
    if (!organiserId) {
      throw new Error("Cannot get group key for invalid exhibitorProfilesPack2Credits item");
    }
    return `${GROUP_KEY_PREFIX}|${organiserId}`;
  },

  getPricingQuery(): Prisma.PricingFindFirstArgs {
    return {
      where: {
        backofficePrestation: {
          type: "exhibitorProfilesPack2Credits",
        },
      },
    };
  },
} as const satisfies BuyableItemHandler;
